(ns manage.content-variant-page.entities.content-optimizing.db
  (:require [clojure.string :as str]
            [common.form.core :as form]
            [re-frame.core :as rf]))

(def entity-name "Optimization")

(def initial-value
  {:algorithm nil
   :algorithm-config {:learningbudget 20}
   :state "started"})

(form/register-form {:namespace :form.content-optimizing
                     :initial-value initial-value
                     :on-change-event :form.content-optimizing/submit
                     :submit-event :form.content-optimizing/submit-form})

(def use-error-message (partial form/use-error-message :form.content-optimizing))

(def use-bind-control (partial form/use-bind-control :form.content-optimizing))

(rf/reg-sub :form.content-optimizing/algorithm-options
  :<- [:resource.content-optimizing/algorithms]
  (fn [{algorithms :value}]
    (->> (select-keys algorithms [:auto_optimizing :learning_budget])
         vals
         (map (fn [{:keys [algorithm]}]
                {:value algorithm
                 :label (-> algorithm
                            (str/replace #"_" " ")
                            (str/capitalize))})))))

(rf/reg-sub :form.content-optimizing/algorithm-config-keys
  :<- [:resource.content-optimizing/algorithms]
  :<- [:form.content-optimizing/value [:algorithm]]
  (fn [[algorithms selected-algorithm]]
    (-> algorithms
        (get-in [:value (keyword selected-algorithm) :algorithm_config])
        keys)))

(rf/reg-event-fx :form.content-optimizing/on-change-algorithm
  (fn [_ [_ path algorithm]]
    {:fx [[:dispatch [:form.content-optimizing/on-change path algorithm]]
          [:dispatch [:form.content-optimizing/on-change [:algorithm-config] (:algorithm-config initial-value)]]]}))

(rf/reg-event-fx :form.content-optimizing/submit-form
  [(rf/inject-cofx :sub :form.content-optimizing/algorithm-config-keys)]
  (fn [{:form.content-optimizing/keys [algorithm-config-keys]} [_ {:keys [algorithm-config] :as form-value}]]
    (let [event (if (:id form-value)
                  :resource.content-optimizing/patch-optimization
                  :resource.content-optimizing/post-optimization)
          payload (assoc form-value :algorithm-config (select-keys algorithm-config algorithm-config-keys))]
      {:fx [[:dispatch-debounced
             {:id :save-optimizations
              :event [event
                      {:params payload
                       :on-success [:form.content-optimizing/submit-form-success payload]
                       :on-failure [:form.content-optimizing/submit-form-failure]}]
              :delay-ms 500}]]})))

(rf/reg-event-fx :form.content-optimizing/submit-form-success
  (fn [{:keys [db]} [_ value response-id]]
    (let [value (cond-> value
                  response-id (assoc :id response-id))]
      {:db (-> db
               (update-in [:resource.content-optimizing/optimizations :value (:test-name value)] merge value)
               (update-in [:form.content-optimizing :value] merge value))
       :fx [[:dispatch [:response-handler/handle-response
                        {:entity-name entity-name
                         :type :success
                         :message "Successfully saved optimization"}]]]})))

(rf/reg-event-fx :form.content-optimizing/submit-form-failure
  (fn [_ [event response]]
    {:fx [[:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :error
                       :event event
                       :message "Failed to save optimization"
                       :response response}]]]}))

(rf/reg-event-fx :form.content-optimizing/open
  [(rf/inject-cofx :sub (fn [[_ ok]] [:ui.store/value ok :variant-feed-key/name]))
   (rf/inject-cofx :sub (fn [[_ ok]] [:optimizing-key/optimizing-arms ok]))]
  (fn [{optimizing-key-name :ui.store/value optimizing-arms :optimizing-key/optimizing-arms :keys [db]} _]
    (let [optimization (get-in db [:resource.content-optimizing/optimizations :value optimizing-key-name])]
      {:fx [[:dispatch [:form.content-optimizing/destroy]]
            [:dispatch [:form.content-optimizing/init (or optimization
                                                          (assoc initial-value
                                                                 :test-name optimizing-key-name
                                                                 :arms optimizing-arms))]]
            [:dispatch [:entity/view {:entity :content-optimization :name optimizing-key-name}]]]})))

;; entity list subs/events

(rf/reg-sub :variant-feed/optimizing-keys
  (fn [[_ vf]]
    (rf/subscribe [:variant-feed/variant-feed-keys vf]))
  (fn [{variant-feed-keys :variant-feed/variant-feed-key} _]
    (sequence (comp
               (filter #(= (:variant-feed-key/type %) :optimizing))
               (map :db/id))
              variant-feed-keys)))

(rf/reg-sub :optimizing-key/optimizing-arms
  (fn [[_ ok]]
    (rf/subscribe [:ui.store/pull-entity [{:optimizing-key/optimizing-arm [:optimizing-arm/value]}] ok]))
  (fn [{optimizing-arms :optimizing-key/optimizing-arm} _]
    (map :optimizing-arm/value optimizing-arms)))

(rf/reg-sub :optimizing-key/optimizing-arms-as-string
  (fn [[_ ok]]
    (rf/subscribe [:optimizing-key/optimizing-arms ok]))
  (fn [optimizing-arms]
    (str/join " · " optimizing-arms)))

(rf/reg-sub :optimizing-key/optimization
  (fn [[_ ok]]
    (rf/subscribe [:ui.store/value ok :variant-feed-key/name]))
  (fn [optimization-key-name]
    @(rf/subscribe [:resource.content-optimizing/optimizations optimization-key-name])))

(rf/reg-event-fx :optimizing-key/configure
  (fn [{:keys [db]} [_ ok]]
    (let [optimizations-loaded? (= :success (get-in db [:resource.content-optimizing/optimizations :state]))]
      {:fx [(if optimizations-loaded?
              [:dispatch [:form.content-optimizing/open ok]]
              [:async-flow {:id :foo
                            :rules [{:when :seen?
                                     :events :resource.content-optimizing/get-optimizations-success
                                     :halt? true
                                     :dispatch [:form.content-optimizing/open ok]}]}])]})))
